import React, { useEffect, useState, useCallback } from "react";
import { useSearchParams, Link } from "react-router-dom";
import Navbar from "../../../Components/Layout/Navbar";
import Footer from "../../../Components/Layout/Footer";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import {jwtDecode} from "jwt-decode";
import axios from "axios";
import Select from "react-select";
import Swal from "sweetalert2";
import { runPaymentCheckout } from "../../../config/appEnv";
import { FaSearch, FaPlus, FaMapMarkerAlt, FaUser, FaRupeeSign, FaBriefcase } from "react-icons/fa";
import { Allwork, locationAll ,workersListBylocation, requestSend, walletRecharge, providerJobAdd} from "../../../Services.js/WorkerApi";
import toast from "react-hot-toast";





const PROVIDER_WORKER_SEARCH_KEY = "providerWorkerSearch";

function Home2() {
  const token = localStorage.getItem("providertoken");
  const [searchParams, setSearchParams] = useSearchParams();
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [showWorkerModal, setShowWorkerModal] = useState(false);
  const [showPostJobModal, setShowPostJobModal] = useState(false);


  const [search, setSearch] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedWork, setSelectedWork] = useState("");

  const [jobTitle, setJobTitle] = useState("");
  const [salaryPerMonth, setSalaryPerMonth] = useState(0);
  const [jobLocation, setJobLocation] = useState(null);
  const [profile,setProfile]=useState(null)
  const [locations,setLocations]=useState([])
  const [works,setWorks]=useState([])

  const [postedJobs, setPostedJobs] = useState([]);
  const [workersMock,setWorkersMock]=useState([])
  const [open, setOpen] = useState(false);
  const [requestTarget, setRequestTarget] = useState(null);
  const [sendingRequest, setSendingRequest] = useState(false);

  const fetchWorkersForSearch = useCallback(
    async (locationId, workId) => {
      const res = await axios.get(
        `${workersListBylocation}?locationId=${encodeURIComponent(locationId)}&workId=${encodeURIComponent(workId)}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return res?.data?.data ?? [];
    },
    [token]
  );

  const handleGetWorkers = async () => {
    if (!selectedLocation?.value || !selectedWork?.value) {
      toast.error("Please select both location and work type");
      return;
    }
    try {
      const list = await fetchWorkersForSearch(
        selectedLocation.value,
        selectedWork.value
      );
      setWorkersMock(list);
      sessionStorage.setItem(
        PROVIDER_WORKER_SEARCH_KEY,
        JSON.stringify({
          locationId: selectedLocation.value,
          workId: selectedWork.value,
          label: selectedLocation.label,
          workLabel: selectedWork.label,
          place: selectedLocation.place,
          town: selectedLocation.town,
          district: selectedLocation.district,
          state: selectedLocation.state,
        })
      );
      setShowLocationModal(false);
      setShowWorkerModal(true);
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        "Could not load workers for this location and work type.";
      toast.error(msg);
    }
  };



const getAllLocation=async()=>{
    try {
       const res = await axios.get(locationAll, {
        headers: { Authorization: `Bearer ${token}` },
      });

       setLocations(res?.data?.data)      
    } catch (error) {
      console.log(error)
      
    }
  }

  const getAllWork=async()=>{
    try {
       const res = await axios.get(Allwork, 
        {
        headers: { Authorization: `Bearer ${token}` },
      });

   setWorks(res?.data?.data)      
    } catch (error) {
      console.log(error)
      
    }
  }

const startWalletCheckout = async (pendingRequest) => {
  try {
    const res = await axios.post(
      walletRecharge,
      {
        amount: 10,
        pendingRequest,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // Backend: { success, data: { order_id, razorpay_order_id, amount, key, ... } }
    const paymentData = res?.data?.data || res?.data;
    if (!paymentData?.razorpay_order_id && !paymentData?.order_id) {
      toast.error(
        res?.data?.message || "Payment order not received from server"
      );
      return;
    }

    if (selectedLocation?.value && selectedWork?.value) {
      sessionStorage.setItem(
        PROVIDER_WORKER_SEARCH_KEY,
        JSON.stringify({
          locationId: selectedLocation.value,
          workId: selectedWork.value,
          label: selectedLocation.label,
          workLabel: selectedWork.label,
          place: selectedLocation.place,
          town: selectedLocation.town,
          district: selectedLocation.district,
          state: selectedLocation.state,
        })
      );
    }

    await runPaymentCheckout({
      paymentData,
      prefill: {
        name: profile?.name || "",
        contact: profile?.contactNo || profile?.phone || "",
      },
      redirectTarget: "_self",
    });
  } catch (error) {
    console.error(error);
    if (error?.message === "Payment cancelled") {
      toast("Payment cancelled");
      return;
    }
    toast.error(
      error?.response?.data?.message ||
        error?.message ||
        "Could not start wallet recharge. Try again."
    );
  }
};

const sendWorkRequest = async (worker) => {
  const receiverId = worker?.userId?._id || worker?.userId;
  if (!receiverId) {
    toast.error("Worker id missing");
    return;
  }

  const pendingRequest = {
    requestType: "worker_request",
    receiverId,
    workId: selectedWork?.value || null,
    locationId: selectedLocation?.value || null,
    userWorkId: worker?._id || null,
  };

  setSendingRequest(true);
  try {
    const res = await axios.post(
      requestSend,
      pendingRequest,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    // Insufficient balance → payment
    if (res?.status === 402 || res?.data?.data?.needPayment) {
      setOpen(false);
      await startWalletCheckout(
        res?.data?.data?.pendingRequest || pendingRequest
      );
      return;
    }

    toast.success("Request sent. Waiting for worker to accept.");
    setOpen(false);
    setRequestTarget(null);
    if (selectedLocation?.value && selectedWork?.value) {
      const list = await fetchWorkersForSearch(
        selectedLocation.value,
        selectedWork.value
      );
      setWorkersMock(list);
    }
  } catch (error) {
    const status = error?.response?.status;
    const data = error?.response?.data;
    if (status === 402 || data?.data?.needPayment) {
      setOpen(false);
      await startWalletCheckout(data?.data?.pendingRequest || pendingRequest);
      return;
    }
    if (status === 409) {
      toast.error("You already have a pending request to this worker");
      return;
    }
    toast.error(data?.message || "Failed to send request");
  } finally {
    setSendingRequest(false);
  }
};

const createPayment = async () => {
  if (requestTarget) {
    await sendWorkRequest(requestTarget);
    return;
  }
  toast.error("Select a worker first");
};





  useEffect(() => {
    getAllLocation();
    getAllWork();
  }, []);

  // After Razorpay + verify: refresh workers for the same location + work (24h unlock)
  useEffect(() => {
    if (searchParams.get("unlock") !== "1") return;

    const raw = sessionStorage.getItem(PROVIDER_WORKER_SEARCH_KEY);
    if (!raw) {
      setSearchParams({}, { replace: true });
      toast("Open Find Worker and search again to see updated contacts.");
      return;
    }

    let saved;
    try {
      saved = JSON.parse(raw);
    } catch {
      setSearchParams({}, { replace: true });
      return;
    }

    const { locationId, workId, label, workLabel, place, town, district, state } =
      saved;
    if (!locationId || !workId) {
      setSearchParams({}, { replace: true });
      return;
    }

    setSelectedLocation({
      value: locationId,
      label: label || place || "Location",
      place,
      town,
      district,
      state,
    });
    setSelectedWork({ value: workId, label: workLabel || "Work" });

    (async () => {
      try {
        const list = await fetchWorkersForSearch(locationId, workId);
        setWorkersMock(list);
        setShowWorkerModal(true);
        toast.success("Payment done — request sent. Contact unlocks after worker accepts.");
      } catch (e) {
        toast.error(
          e?.response?.data?.message || "Could not refresh worker list."
        );
      } finally {
        setSearchParams({}, { replace: true });
      }
    })();
  }, [searchParams, setSearchParams, fetchWorkersForSearch]);

  const locationOptions = locations.map((loc) => ({
  value: loc._id,
  label: `${loc.place}, ${loc.town}, ${loc.district}, ${loc.state}`,
  state: loc.state,
  district: loc.district,
  town: loc.town,
  place: loc.place,
}));

  const workOptions = works.map((work) => ({
  value: work._id,
  label: `${work.name}`,
}));

useEffect(() => {
  if (token) {
    const decoded = jwtDecode(token);
    setProfile(decoded);
  }
}, [token]);

  const handlePostJob = async () => {
    if (!jobTitle || !jobLocation) {
      toast.error("Please enter job title and select location");
      return;
    }

    try {
      const res = await axios.post(
        providerJobAdd,
        {
          locationId: jobLocation.value,
          jobTitle: jobTitle.trim(),
          salaryPerMonth: parseInt(salaryPerMonth),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );


      if (res?.status=== 201) {
        toast.success(res?.data?.message || "Job added successfully");
        const savedJob = res?.data?.data;
        const jobWithLocation = {
          ...savedJob,
          locationLabel: jobLocation.label,
        };
        setPostedJobs((prev) => [jobWithLocation, ...prev]);
        setShowPostJobModal(false);
        setJobTitle("");
        setSalaryPerMonth(0)
        setJobLocation(null);
      } else {
        toast.error(res?.data?.message || "Failed to add job");
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message || "Failed to add job");
    }
  };

  return (
    <div className="w-full bg-gray-50 min-h-screen">
      <Navbar />
      <h1 className="hidden">Book Daily Wage Workers in Kerala</h1>

      <div className="min-h-[90vh] p-4 md:p-6 max-w-7xl mx-auto space-y-6">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900">Welcome Back, <span className="text-red-600">{profile?.name}</span></h1>
            <p className="text-gray-600 mt-1">Find skilled workers or post your work requirements</p>
          </div>
          <div className="flex gap-3">
            <button
              onClick={() => setShowLocationModal(true)}
              className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition flex items-center gap-2 shadow-md"
            >
              <FaUser className="text-sm" />
              Find Worker
            </button>
            <button
              onClick={() => setShowPostJobModal(true)}
              className="px-4 py-2 bg-black text-white rounded-lg hover:bg-gray-800 transition flex items-center gap-2 shadow-md"
            >
              <FaPlus className="text-sm" />
              Post Job
            </button>
            <Link
              to="/provider-requests"
              className="px-4 py-2 bg-white border border-gray-300 text-gray-800 rounded-lg hover:bg-gray-50 transition flex items-center gap-2 shadow-sm"
            >
              Requests
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

            <div className="lg:col-span-2">
            <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-bold text-gray-900 flex items-center gap-2">
                  <FaBriefcase className="text-red-600" />
                  Your Posted Work
                </h2>
                <button
                  onClick={() => setShowPostJobModal(true)}
                  className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition flex items-center gap-2 text-sm"
                >
                  <FaPlus />
                  Add New Job
                </button>
              </div>

              {postedJobs.length > 0 ? (
                <div className="space-y-4">
                  {postedJobs.map((job) => (
                    <div
                      key={job._id}
                      className="border border-gray-200 rounded-xl p-4 hover:border-red-200 hover:bg-red-50 transition"
                    >
                      <div className="flex justify-between items-start">
                        <div>
                          <h3 className="font-bold text-lg text-gray-900">
                            {job.jobTitle}
                          </h3>
                          <p className="text-gray-600 text-sm mt-1">
                            Posted on{" "}
                            {job.createdAt
                              ? new Date(job.createdAt).toLocaleDateString("en-IN")
                              : "-"}
                          </p>
                          {job.locationLabel && (
                            <p className="text-gray-500 text-sm mt-2">
                              Location: {job.locationLabel}
                            </p>
                          )}
                        </div>
                        <div className="text-right">
                          <span className="px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800">
                            Active
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-12">
                  <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <FaBriefcase className="text-gray-400 text-2xl" />
                  </div>
                  <h3 className="text-lg font-semibold text-gray-700 mb-2">No jobs posted yet</h3>
                  <p className="text-gray-500 mb-4">Post your first job and find skilled workers</p>
                  <button
                    onClick={() => setShowPostJobModal(true)}
                    className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
                  >
                    Post Your First Job
                  </button>
                </div>
              )}
            </div>
          </div>
          {/* Left Column - Profile & Stats */}
          <div className="lg:col-span-1 space-y-6">
            {/* Profile Card */}
            <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
                  <span className="text-2xl font-bold text-red-600">  {profile?.name ? profile.name.charAt(0).toUpperCase() : "U"}</span>
                </div>
                <div>
                  <h2 className="text-xl font-bold text-gray-900">{profile?.name}</h2>
                  <p className="text-gray-600">📱 {profile?.contactNo}</p>
                  <span className="inline-block mt-1 px-3 py-1 bg-red-50 text-red-600 rounded-full text-sm">
                    Verified User
                  </span>
                </div>
              </div>
              
              <div className="grid invisible grid-cols-2 gap-4">
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="text-sm text-gray-500">Jobs Posted</p>
                  <p className="text-2xl font-bold text-gray-900">{postedJobs.length}</p>
                </div>
                <div className="bg-red-50 p-4 rounded-lg">
                  <p className="text-sm text-red-500">Active Jobs</p>
                  <p className="text-2xl font-bold text-red-600">
                    {postedJobs.filter(job => job.status === "Pending").length}
                  </p>
                </div>
              </div>
            </div>

            {/* Quick Stats */}
            {/* <div className="bg-black text-white rounded-xl shadow-lg p-6">
              <h3 className="text-lg font-bold mb-4 flex items-center gap-2">
                <FaBriefcase />
                Quick Stats
              </h3>
              <div className="space-y-3">
                <div className="flex justify-between items-center">
                  <span className="text-gray-300">Total Spent</span>
                  <span className="font-bold">₹4,000</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-300">Workers Hired</span>
                  <span className="font-bold">3</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-300">Avg. Rating</span>
                  <span className="font-bold">4.5 ★</span>
                </div>
              </div>
            </div> */}
          </div>

          {/* Right Column - Posted Jobs */}
          
        </div>
      </div>

      {/* Location Modal */}
     {showLocationModal && (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
    <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl">
      
      {/* Header */}
      <div className="bg-red-600 p-6 rounded-t-2xl">
        <h3 className="text-xl font-bold text-white flex items-center gap-2">
          <FaMapMarkerAlt />
          Select Your Location and Work
        </h3>
      </div>

      {/* Body */}
      <div className="p-6">
        <div className="relative mb-4">

          {/* Location Select */}
          <Select
            options={locationOptions}
            value={selectedLocation}
            onChange={setSelectedLocation}
            placeholder="Search location"
            isSearchable
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 })
            }}
          />

          {/* Work Select */}
          <Select
            className="mt-4"
            options={workOptions}
            value={selectedWork}
            onChange={setSelectedWork}
            placeholder="Search work"
            isSearchable
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 })
            }}
          />

        </div>
      </div>

      {/* Footer */}
      <div className="p-4 border-t">
        <div className="flex justify-end gap-3">

          <button
            onClick={() => {
              setShowLocationModal(false);
              setSelectedLocation(null);
              setSelectedWork(null);
            }}
            className="px-5 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition"
          >
            Cancel
          </button>

          <button
            onClick={handleGetWorkers}
            disabled={!selectedLocation || !selectedWork}
            className="px-5 py-2.5 bg-red-600 text-white rounded-lg hover:bg-red-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Find Workers
          </button>

        </div>
      </div>

    </div>
  </div>
)}

      {/* Worker List Modal */}
      {showWorkerModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
          <div className="bg-white w-full max-w-2xl rounded-2xl shadow-2xl overflow-hidden">
            <div className="bg-black p-6">
              <h3 className="text-xl font-bold text-white flex items-center gap-2">
                <FaUser />
                Available Workers in {selectedLocation?.place}
              </h3>
              <p className="text-gray-300 text-sm mt-1">Select a worker to hire</p>
            </div>

     
            
            <div className="p-6">
              {workersMock?.length==0?(<div><p>No worker Found in these location</p>
              <p>ഈ ലൊക്കേഷനിൽ വർക്കേഴ്സ് ആരും ഇല്ല.</p></div>):(
<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {workersMock.map((worker) => (
                  <div
                    key={worker._id || worker.id}
                    className="border border-gray-200 rounded-xl p-5 hover:border-red-300 hover:shadow-md transition"
                  >
                    <div className="flex justify-between items-start">
                      <div>
                        <h4 className="font-bold text-lg text-gray-900">{worker?.userId?.name}</h4>
                        <div className="flex items-center gap-2 mt-2">
                          {/* <span className="px-2 py-1 bg-red-100 text-red-600 rounded text-sm font-medium">
                            {worker.rating} ★
                          </span> */}
                          <span className="text-gray-600 text-sm">{worker.experience}</span>
                        </div>
                      </div>
                      <div className="text-right">
                        <p className="text-2xl font-bold text-gray-900 flex items-center gap-1">
                          <FaRupeeSign className="text-lg" />
                          {worker.amountForWork}
                        </p>
                        <p className="text-gray-500 text-sm">per {worker?.amountType}</p>
                      </div>
                    </div>
                 

{worker?.userId?.contactNo || worker?.contactStatus === "unlocked" ? (
    <>
    <h4>Contact :- {worker.userId.contactNo}</h4>
     <div className="mt-4 flex gap-3">

    {/* Call Button */}
    <a
      href={`tel:${worker.userId.contactNo}`}
      className="flex items-center justify-center gap-2 w-1/2 px-4 py-2.5 bg-green-600 text-white rounded-lg hover:bg-green-700 transition"
    >
      <FaPhoneAlt className="text-sm" />
      Call
    </a>

    {/* WhatsApp Button */}
    <a
      href={`https://wa.me/${worker.userId.contactNo}`}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center justify-center gap-2 w-1/2 px-4 py-2.5 bg-emerald-500 text-white rounded-lg hover:bg-emerald-600 transition"
    >
      <FaWhatsapp className="text-lg" />
      WhatsApp
    </a>
  </div>
    </>
 
) : worker?.requestStatus === "pending" ? (
  <button
    disabled
    className="w-full mt-4 flex items-center justify-center gap-2 px-4 py-2.5 bg-amber-500 text-white rounded-lg opacity-90 cursor-default"
  >
    Request Pending
  </button>
) : (
  <button
    onClick={() => {
      setRequestTarget(worker);
      setOpen(true);
    }}
    className="w-full mt-4 flex items-center justify-center gap-2 px-4 py-2.5 bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
  >
    Send Request
  </button>
)}

                  
                  </div>
                ))}
              </div>
              )}
              

              <div className="text-center mt-6 pt-6 border-t">
                <button
                  onClick={() => setShowWorkerModal(false)}
                  className="px-5 py-2.5 bg-gray-800 text-white rounded-lg hover:bg-gray-900 transition"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Post Job Modal */}
      {showPostJobModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
          <div className="bg-white w-full max-w-2xl rounded-2xl shadow-2xl overflow-hidden relative">
            <div className="bg-red-600 p-4">
              <button
                type="button"
                onClick={() => {
                  setShowPostJobModal(false);
                  setJobTitle("");
                  setSalaryPerMonth(0);
                  setJobLocation(null);
                }}
                className="absolute top-3 right-3 text-white/80 hover:text-white text-2xl leading-none"
              >
                ×
              </button>
              <h3 className="text-xl font-bold text-white flex items-center gap-2">
                <FaBriefcase />
                Post a Job
              </h3>
              <p className="text-red-100 text-sm mt-1">
                Share your work requirement and we’ll notify workers in the selected location
              </p>
            </div>

            <div className="p-6">
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Job Title *
                  </label>
                  <input
                    type="text"
                    placeholder="Enter the job Name"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
                    value={jobTitle}
                    onChange={(e) => setJobTitle(e.target.value)}
                  />
                </div>

                

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Location *
                  </label>
                  <Select
                    options={locationOptions}
                    value={jobLocation}
                    onChange={setJobLocation}
                    placeholder="Select job location"
                    isSearchable
                  />
                  {jobLocation && (
                    <p className="mt-2 text-xs text-gray-500">
                      {jobLocation.place}, {jobLocation.town}, {jobLocation.district},{" "}
                      {jobLocation.state}
                    </p>
                  )}
                </div>
              </div>


              <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Job Title *
                  </label>
                  <input
                    type="number"
                    placeholder="Enter the Salary Per Month"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
                    value={salaryPerMonth}
                    onChange={(e) => setSalaryPerMonth(e.target.value)}
                  />
                </div>

              <div className="flex justify-end gap-3 mt-8 pt-6 border-t">
                <button
                  onClick={() => {
                    setShowPostJobModal(false);
                    setJobTitle("");
                    setJobLocation(null);
                  }}
                  className="px-5 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition"
                >
                  Cancel
                </button>
                <button
                  onClick={handlePostJob}
                  disabled={!jobTitle || !jobLocation}
                  className="px-5 py-2.5 bg-red-600 text-white rounded-lg hover:bg-red-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Post Job
                </button>
              </div>
            </div>
          </div>
        </div>
      )}


      {open && (
  <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
  <div className="bg-white rounded-xl p-6 w-full max-w-sm shadow-2xl">
    <h2 className="text-xl font-bold mb-3 text-gray-900">Send Work Request</h2>
    
    <div className="space-y-3 mb-6">
      <p className="text-sm text-gray-600 leading-relaxed">
        Spend <strong>₹10 from your wallet</strong> to send a request to{" "}
        <strong>{requestTarget?.userId?.name || "this worker"}</strong>.
        Contact details unlock only after they accept (24 hours).
      </p>
      
      <div className="bg-blue-50 p-3 rounded-lg">
        <p className="text-blue-900 font-semibold">₹10 — deducted from wallet</p>
        <p className="text-blue-800 text-xs mt-1">If wallet balance is low, you will recharge ₹10 first.</p>
      </div>

      <p className="text-sm text-gray-700 font-medium leading-relaxed border-t pt-3">
      അഭ്യർത്ഥന അയച്ച് വർക്കർ സ്വീകരിച്ചാൽ മാത്രമേ നമ്പർ കാണൂ. നിരസിച്ചാൽ ₹10 വാലറ്റിലേക്ക് തിരികെ.
      </p>
    </div>

    <div className="flex justify-end items-center gap-4">
      <button
        onClick={() => {
          setOpen(false);
          setRequestTarget(null);
        }}
        className="text-gray-600 hover:text-black font-medium transition-colors"
      >
        Cancel
      </button>

      <button
        disabled={sendingRequest}
        onClick={() => {
          createPayment();
        }}
        className="bg-red-600 hover:bg-red-700 text-white px-6 py-2.5 rounded-full font-bold shadow-md transition-all active:scale-95 disabled:opacity-50"
      >
        {sendingRequest ? "Sending…" : "Send Request"}
      </button>
    </div>
  </div>
</div>
)}


      <Footer />
    </div>
  );
}

export default Home2;